<template>
  <div>
    <h3 class="header-title">Learning Student</h3>
    <label>Let’s see your tuition student.</label>
    <br />
    <label>
      You have subscribed to the {{ user.packageName }} package, which is valid
      until {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}} 
      {{ user.invoiceprice }} and includes a limit of
      {{ check.NumberOfStudent }} students and
      <span v-if="check.TotalTeacher === 0">Unlimited</span
      ><span v-else>{{ check.TotalTeacher }} </span> teachers.
    </label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your student !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
              >X ERROR ! Your subscription package has expired. Please renew
              your current subscription or upgrade to a new package.
            </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()"
              >Renew</CButton
            >
          </CCol>
        </CRow>
      </CAlert>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-2">
        <CRow>
          <CCol sm="12">
            Click to show all including inactive student 
            <CButton type="button" class="btn-info ml-4" @click="ShowAll()"
              >Show All</CButton
            >
          
          </CCol>
          <br /><br />
          <CCol sm="3">
            <div class="custom-file">
              <label
                class="custom-file-label"
                for="customFile"
                v-if="files.length == 0"
                >Choose CSV file</label
              >
              <label class="custom-file-label" for="customFile" v-else>{{
                files[0].name
              }}</label>
              <input
                type="file"
                id="file"
                ref="myFiles"
                class="custom-file-input"
                @change="ConvertCsvToJson()"
                accept=".csv"
              />
            </div>
            <label>
              CSV file contains
              <b>{{ parsedCsvData.length }}</b> number of records.
            </label>
            <br /><br />
          </CCol>

          <CCol sm="2">
            <CButton class="custom-btn-lights" @click="InsertImportStudent()"
              >Upload</CButton
            >
          </CCol>
          <CCol sm="4"></CCol>
          <CCol sm="3" class="float-right">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <v-select
              v-model="selectedGrade"
              :options="gradeOptions"
              label="Class"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="3">
            <v-select
              v-model="selectedClass"
              :options="classOptions"
              label="Class"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <CCol sm="3">   <v-select
              v-model="selectedStatus"
              :options="statusOptions"
              label="Status"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select></CCol>
        </CRow>
      </CCol>
      <CCol sm="12">            
        <div class="table-container">

        <CDataTable
          class="d-sm-down-none"
          :items="
            user.validTo < currentDate
              ? FilteredStudentsList.slice(0, 5)
              : FilteredStudentsList
          "
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          clickable-rows
          sorter
          pagination
        >
          <template #ID="{ item }">
            <td>
              <strong> {{ item.Id }} </strong>
            </td>
          </template>

          <template #Profile="{ item }">
            <td>
              <img
                v-if="item.profileImagePath == null"
                style="
                  border: 1px solid #eee;
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                :src="getPicChild(item)"
                class="grey lighten-2 mt-2"
              />
            </td>
          </template>

          <template #StudentDetail="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.Name }}
              </h6>
              <CBadge v-if="item.Status == 'active'" color="success"
                >Active</CBadge
              >
              <CBadge v-else-if="item.Status == 'inactive'" color="danger"
                >InActive</CBadge
              >
              <CBadge v-else color="warning"></CBadge>
              <div class="small text-muted">
                Parent Name : {{ item.ParentName }} / {{ item.ParentEmail }}
              </div>
              <div class="small text-muted">Grade : {{ item.Grade }}</div>
              <div class="small text-muted">Class : {{ item.Class }}</div>
              <div class="small text-muted">Parent H/P : {{ item.Phone }}</div>
              <div class="small text-muted">
                Registered : {{ item.Register | moment("MMM YYYY") }}
              </div>
              <div class="small text-muted">
                <CBadge
                  color="warning"
                  class="ml-auto"
                  v-if="item.Rate == 'monthly'"
                  >{{ item.Rate }}</CBadge
                >
                <CBadge color="info" class="ml-auto" v-else>{{
                  item.Rate
                }}</CBadge>
              </div>
            </td>
          </template>

          <template #PackageSubjects="{ item }">
            <!-- <td>
              <CRow v-for="su in item.Packages" :key="su.Id">
              <CCol sm="12"> {{ su.Name }} - RM {{ su.StudentFee }}
                <br />
              List Subject: <br />
                <ul v-for="sub in su.Subjects" v-bind:key="sub.Id">
                <li><strong><i>{{ sub.Name }}</i></strong></li>
                  </ul></CCol>
            </CRow>
            </td> -->

            <td>
              <CRow v-for="su in item.Packages" :key="su.Id">
                <CCol sm="12"
                  ><ul>
                    <li>{{ su.Name }} - RM {{ su.StudentFee }}</li>
                  </ul>
                </CCol>
                <!-- <CCol sm="6">
                  List Subject: <br />
                <ul v-for="sub in su.Subjects" v-bind:key="sub.Id">
                <li><strong><i>{{ sub.Name }}</i></strong></li>
                  </ul>
                </CCol> -->
              </CRow>
            </td>
          </template>

          <template #SubjectClass="{ item }">
            <td>
              <div v-for="su in item.Packages" :key="su.Id">
                <ul v-for="sub in su.Subjects" v-bind:key="sub.Id">
                  <li>
                    {{ sub.Name }} <br />
                    Teacher: <i class="small text-muted"> {{ sub.Teacher }}</i>
                  </li>
                </ul>
              </div>
            </td>
          </template>

          <template #Cost="{ item }">
            <td>
              Discount:
              <strong style="color: #1e109c">
                <span v-if="item.Discount == null">{{ user.currencyCode}}  0</span
                ><span v-else>{{ user.currencyCode}} {{ item.Discount }}</span></strong
              >
              <br />
              Total Fee:
              <strong style="color: #1e109c"
                >{{ user.currencyCode}}  {{ item.TotalFee - item.Discount }}</strong
              >
            </td>
          </template>

          <template #Action="{ item }">
            <td>
              <CDropdown
                toggler-text="Action"
                class="m-2 btn-act"
                color="primary"
              >
                <CDropdownItem @click="OpenStudentModal(item)"
                  >Detail Student</CDropdownItem
                >
                <!-- <CDropdownItem @click="OpenStudentDirectFT(item)"
                  >Add Schedule Find Tutor</CDropdownItem
                > -->
                <CDropdownItem @click="OpenDiscountModal(item)"
                  >Add Discount</CDropdownItem
                >
                <CDropdownItem @click="OpenAssignPackageModal(item)"
                  >Assign Package</CDropdownItem
                >
                <hr />
                <CDropdownItem @click="OpenUpdateStudent(item)"
                  >Edit Student</CDropdownItem
                >

                <CDropdownItem @click="OpenInactiveModal(item)"
                  >Delete Student</CDropdownItem
                >
              </CDropdown>
            </td>
          </template>
        </CDataTable>

        <CDataTable
          class="d-sm-flex d-md-none"
          :items="
            user.validTo < currentDate
              ? FilteredStudentsList.slice(0, 5)
              : FilteredStudentsList
          "
          :fields="fieldsResponsive"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          clickable-rows
          sorter
          pagination
        >
          <template #ID="{ item }">
            <td>
              <img
                v-if="item.profileImagePath == null"
                style="
                  border: 1px solid #eee;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                :src="getPicChild(item)"
                class="grey lighten-2 mt-2"
              />
              <div class="text-center">
                <strong class="text-center m-0"> {{ item.Id }} </strong>
              </div>
            </td>
          </template>

          <template #StudentDetail="{ item }">
            <td>
              <h6
                style="color: #1e109c; font-size: 12px"
                class="text-uppercase"
              >
                {{ item.Name }}
              </h6>
              <div class="small text-muted">
                Parent Name : {{ item.ParentName }} / {{ item.ParentEmail }}
              </div>
              <div class="small text-muted">Grade : {{ item.Grade }}</div>
              <div class="small text-muted">Class : {{ item.Class }}</div>
              <div class="small text-muted">Parent H/P : {{ item.Phone }}</div>
              <div class="small text-muted">
                Registered : {{ item.Register | moment(" MMM YYYY") }}
              </div>
              <div class="small text-muted">
                <CBadge
                  color="warning"
                  class="ml-auto"
                  v-if="item.Rate == 'monthly'"
                  >{{ item.Rate }}</CBadge
                >
                <CBadge color="info" class="ml-auto" v-else>{{
                  item.Rate
                }}</CBadge>
              </div>
              <br />
              <h6 style="color: #1e109c" class="text-uppercase">
                List Package
              </h6>
              <tr v-for="su in item.Packages" :key="su.Id">
                <li class="small">{{ su.Name }} - {{ su.StudentFee }}</li>
                <span v-for="sub in su.Subjects" v-bind:key="sub.Id">
                  <CBadge color="light">{{ sub.Name }}</CBadge>
                  <br />
                    Teacher: <i class="small text-muted"> {{ sub.Teacher }}</i>
                    <br />
                </span>
              </tr>
              </td>

       
          </template>

          <template #Cost="{ item }">
            <td>
              <span class="small text-muted">
                Discount:
                <strong style="color: #1e109c">
                  <br />
                  <span v-if="item.Discount == null">{{ user.currencyCode}}  0</span
                  ><span v-else>{{ user.currencyCode}}  {{ item.Discount }}</span></strong
                >
                <br />
                Total Fee:
                <strong style="color: #1e109c"
                  ><br />
                  {{ user.currencyCode}}  {{ item.TotalFee - item.Discount }}</strong
                >
              </span>
            </td>
          </template>
          <template #Action="{ item }">
            <td>
              <CDropdown
                toggler-text="Action"
                class="m-2 btn-act"
                color="primary"
              >
                <CDropdownItem @click="OpenStudentModal(item)"
                  >Detail Student</CDropdownItem
                >
                <CDropdownItem @click="OpenDiscountModal(item)"
                  >Add Discount</CDropdownItem
                >
                <CDropdownItem @click="OpenAssignPackageModal(item)"
                  >Assign Package</CDropdownItem
                >
                <hr />
                <CDropdownItem @click="OpenUpdateStudent(item)"
                  >Edit Student</CDropdownItem
                >

                <CDropdownItem @click="OpenInactiveModal(item)"
                  >Delete Student</CDropdownItem
                >
              </CDropdown>
            </td>
          </template>
        </CDataTable>
        </div>
      </CCol>

      <CModal size="md" :show.sync="StudentDetailModal">
        <CRow
          v-for="item in studentDetails.StudentRegInfo"
          v-bind:key="item.Id"
        >
          <CCol sm="12">
            <CCardBody>
              <CForm>
                <fieldset>
                  <legend>Student Detail</legend>

                  <CRow class="pl-2 pr-2">
                    <CCol sm="4"> <label>Student Name</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.FullName }}</strong
                        ></label
                      ></CCol
                    >
                    <CCol sm="4"> <label>Status</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.Status }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>IC Number</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.IdentityCertificateNumber }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Gender</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.Gender }}</strong
                        ></label
                      ></CCol
                    >
                    <CCol sm="4"> <label>Birth Date</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.BirthDate }}</strong
                        ></label
                      ></CCol
                    >
                    <CCol sm="4"> <label>Student Class</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ studentDetails.Class }}</strong
                        ></label
                      ></CCol
                    >
                    <CCol sm="4"> <label>Student Grade</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ studentDetails.Grade }}</strong
                        ></label
                      ></CCol
                    >
                    <CCol sm="4"> <label>Age</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.Age }}</strong
                        ></label
                      ></CCol
                    >
                    <CCol sm="4"> <label>Package Interest</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.PackageInterest }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Allergy</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.FoodAllergy }}</strong
                        ></label
                      ></CCol
                    >
                    <CCol sm="4"> <label>Facebook</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.Facebook }}</strong
                        ></label
                      ></CCol
                    >
                  </CRow>
                </fieldset>
                <br />
                <fieldset>
                  <legend>Parent Detail</legend>

                  <CRow class="pl-2 pr-2">
                    <CCol sm="4"> <label>Parent Name</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.ParentName }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Parent Email</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.ParentEmail }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Parent Phone</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ studentDetails.ParentPhoneNumber }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Main Contact</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.MainContactNumber }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Occupation</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.Occupation }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>State</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.State }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Father Phone</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.FatherPhoneNumber }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Zip Code</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.ZipCode }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>School Name</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.SchoolName }}</strong
                        ></label
                      ></CCol
                    >

                    <CCol sm="4"> <label>Remark</label></CCol>
                    <CCol sm="8">
                      <label
                        ><strong class="font-weight-700"
                          >: {{ item.Remarks }}</strong
                        ></label
                      ></CCol
                    >
                  </CRow>
                </fieldset>
              </CForm>
            </CCardBody>
          </CCol>
        </CRow>
      </CModal>

      <CModal title="Add Discount" size="md" :show.sync="DiscountModal">
        <div>
          Student Name: {{ studentDetails.Name }}
          <br />
          Email: {{ studentDetails.StudentEmail }} <br />
          <br />
          <h6><strong>FORM DISCOUNT</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="3"> Discount </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="Discount" />
              </CCol>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="UpdateDiscount(studentDetails.Id)"
            >Proceed</CButton
          ></template
        >
      </CModal>

      <CModal title="Assign Package" size="md" :show.sync="AssignPackageModal">
        <div>
          Student Name: {{ studentDetails.Name }}
          <br />
          Email: {{ studentDetails.StudentEmail }} <br />
          Parent Email: {{ studentDetails.ParentEmail }} <br />
          <br />
          <h6><strong>ADD ASSIGN PACKAGE</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Package </CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedPackage"
                  :options="packages"
                  label="Name"
                  placeholder="--Please Select Package--"
                ></v-select>
              </CCol>
            </CRow>
          </CCol>

          <br />
          <h6><strong>REMOVE PACKAGE</strong></h6>
          <br />
          <div style="clear: both"></div>
          <CCol sm="12">
            <CDataTable
              :small="small"
              :fixed="fixed"
              :items="studentpackages"
              :fields="fieldsPackages"
              items-per-page-select
              :items-per-page="small ? 5 : 5"
              clickable-rows
              pagination
              table-filter
            >
              <template #Name="{ item }">
                <td>
                  {{ item.Name }}
                </td>
              </template>
              <template #Action="{ item }">
                <td>
                  <CButton
                    type="button"
                    class="btn btn-danger"
                    @click="OpenDeletePackages(item, studentDetails.Id)"
                  >
                    <CIcon name="cil-trash"
                  /></CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="CreateAssignPackage(studentDetails.Id)"
            >Proceed</CButton
          ></template
        >
      </CModal>

      <CModal title="Edit Student" size="md" :show.sync="StudentModal">
        <div>
          <h6><strong>STUDENT DETAIL</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Student Name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="StudentNames" />
              </CCol>

              <CCol sm="4"> Student Email </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="StudentEmails" />
              </CCol>

              <CCol sm="4"> Parent Email</CCol>
              <CCol sm="8">
                <CInput type="text" v-model="ParentEmails" />
              </CCol>

              <CCol sm="4"> Parent Phone Number </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="ParentPhoneNumbers" />
              </CCol>

              <CCol sm="4"> Grade</CCol>
              <CCol sm="8">
                <v-select
                  v-model="SelectedGradeNames"
                  :options="gradesName"
                  label="Name"
                  placeholder="--Please Select Grade--"
                ></v-select>
                <br />
              </CCol>

              <CCol sm="4"> Class Name</CCol>
              <CCol sm="8">
                <v-select
                  v-model="SelectedClassNames"
                  :options="classes"
                  label="Name"
                  placeholder="--Please Select Class--"
                ></v-select>
                <br />
              </CCol>

              <!-- <CCol sm="4"> Choose Rate Type</CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedRate"
                  :options="rates"
                  label="Rate"
                  placeholder="--Please Select Rate--"
                ></v-select>
                 <br />
              </CCol> -->
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="UpdateStudent(studentDetails.Id)"
            >Proceed</CButton
          ></template
        >
      </CModal>

      <CModal title="Inactive Student" size="md" :show.sync="InactiveModal">
        <div>
          Are you sure you want inactive {{ studentDetails.Name }} ?
          <br />
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="UpdateStudentStatus(studentDetails.Id)"
            >Proceed</CButton
          ></template
        >
      </CModal>

      <CModal title="Direct Find Tutor" size="md" :show.sync="FTModal">
        <div>
          <h6><strong>STUDENT DETAIL</strong></h6>
          <br />
          <CRow>
            <CCol class="justify-content-center" sm="12" lg="12">
              <div>
                <CCol sm="12" lg="12">
                  <CRow>
                    <CCol sm="4" lg="4"> <label>Group</label></CCol>
                    <CCol sm="8" lg="8">
                      <input
                        @click="OpenOneToOne"
                        type="radio"
                        v-model="group"
                        value="OneToOne"
                        required
                      />
                      One To One
                      <input
                        @click="OpenGroupOfTwo"
                        type="radio"
                        class="text-dark ml-4"
                        v-model="group"
                        value="GroupOfTwo"
                        required
                      />
                      Group Of Two
                    </CCol>

                    <CCol v-if="OneToOneForm == true" sm="12" lg="12">
                      <CRow>
                        <CCol sm="4" lg="4" class="mt-3">
                          <label>Student</label></CCol
                        >
                        <CCol sm="8" lg="8">
                          <v-select
                            ref="select"
                            v-model="SelectedStudent"
                            :options="students"
                            label="Name"
                            placeholder="--Please Select Student Name--"
                            required
                          >
                            <span
                              slot="no-options"
                              @click="$refs.select.open = false"
                            >
                              Please Register Student
                            </span></v-select
                          >
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol v-if="GroupOfTwoForm == true" sm="12" lg="12">
                      <CRow>
                        <CCol sm="4" lg="4" class="mt-3">
                          <label>Student 1</label></CCol
                        >
                        <CCol sm="8" lg="8" class="mt-3">
                          <v-select
                            ref="select"
                            v-model="SelectedStudent"
                            :options="students"
                            label="Name"
                            placeholder="--Please Select Student Name--"
                            required
                          >
                            <span
                              slot="no-options"
                              @click="$refs.select.open = false"
                            >
                              Please Register Student
                            </span></v-select
                          >
                        </CCol>
                        <CCol sm="4" lg="4" class="mt-3">
                          <label>Student 2</label></CCol
                        >
                        <CCol sm="8" lg="8" class="mt-3">
                          <v-select
                            ref="select"
                            v-model="SelectedStudent2"
                            :options="students"
                            label="Name"
                            placeholder="--Please Select Student Name--"
                            required
                          >
                            <span
                              slot="no-options"
                              @click="$refs.select.open = false"
                            >
                              Please Register Student
                            </span></v-select
                          >
                        </CCol>
                      </CRow>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3">
                      <label>Subject</label></CCol
                    >
                    <CCol sm="8" lg="8" class="mt-3">
                      <v-select
                        v-model="SelectedSubject"
                        :options="subjects"
                        label="SubjectName"
                        placeholder="--Please Select Subject--"
                        required
                      ></v-select>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3">
                      <label>Grade</label></CCol
                    >
                    <CCol sm="8" lg="8" class="mt-3">
                      <v-select
                        v-model="SelectedGrades"
                        :options="grades"
                        label="GradeName"
                        placeholder="--Please Select Level--"
                        required
                      ></v-select>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3">
                      <label>Language</label></CCol
                    >
                    <CCol sm="8" lg="8" class="mt-3">
                      <span v-for="item in languages" v-bind:key="item.Id">
                        <input
                          type="checkbox"
                          v-model="item.isAccepted"
                          class="mr-2 ml-2"
                        /><span class="text-dark">
                          {{ item.Name }}
                        </span>
                      </span>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3">
                      <label>Session</label></CCol
                    >
                    <CCol sm="8" lg="8" class="mt-3">
                      <span
                        v-for="item in sessions"
                        v-bind:key="item.Id"
                        style="font-size: 15px"
                      >
                        <input
                          type="checkbox"
                          v-model="item.isAccepted"
                          class="mr-2 ml-2"
                        /><span class="text-dark">
                          {{ item.Name }}
                        </span>
                      </span>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3"> <label>Time</label></CCol>
                    <CCol sm="8" lg="8" class="mt-3">
                      <span
                        v-for="item in times"
                        v-bind:key="item.Id"
                        style="font-size: 15px"
                      >
                        <input
                          type="checkbox"
                          v-model="item.isAccepted"
                          class="mr-2 ml-2"
                        /><span class="text-dark">
                          {{ item.Name }}
                        </span>
                      </span>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3">
                      <label>Class Duration</label></CCol
                    >
                    <CCol sm="8" lg="8" class="mt-3">
                      <span v-for="item in dur" v-bind:key="item.Id">
                        <input
                          name="item.Id"
                          type="radio"
                          value="item.Id"
                          v-model="durationID"
                          @change="durationID = item.Id"
                          class="mr-2 ml-2"
                        /><span class="text-dark">
                          {{ item.Name }}
                        </span>
                      </span>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3">
                      <label>Teacher</label></CCol
                    >
                    <CCol sm="8" lg="8" class="mt-3">
                      <v-select
                        v-model="SelectedTeacher"
                        :options="list"
                        label="Name"
                        placeholder="--Please Select Teacher--"
                        required
                      ></v-select>
                    </CCol>

                    <CCol sm="4" lg="4" class="mt-3">
                      <label>Start Time</label></CCol
                    >
                    <CCol sm="8" lg="8" class="mt-3">
                      <CInput type="datetime-local" v-model="StartTime" />
                    </CCol>
                  </CRow>
                </CCol>
              </div>
            </CCol>
            <br />

            <CCol class="justify-content-center mt-4" sm="12" lg="12"> </CCol>
          </CRow>
        </div>
        <template #footer>
          <CButton
            v-if="OneToOneForm == true"
            style="background: #1565d8"
            color="primary"
            @click="DirectOneToOne"
            >Proceed</CButton
          >

          <CButton
            v-if="GroupOfTwoForm == true"
            style="background: #1565d8"
            color="primary"
            @click="DirectGroupOfTwo"
            >Proceed</CButton
          ></template
        >
      </CModal>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VueJsonToCsv from "vue-json-to-csv";
import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);
import download from "downloadjs";
Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

export default {
  name: "Tables",
  components: {
    PulseLoader,
    VueJsonToCsv,
  },
  data() {
    return {
      files: "",
      parsedCsvData: [],
      students: [],
      SearchQuery: "",
      FilteredStudents: [],

      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],

      selectedStatus: "ALL STATUS",
      statusOptions: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,

      Busy: false,

      fields: [
        { key: "ID" },
        { key: "Profile" },
        { key: "StudentDetail" },
        { key: "PackageSubjects" },
        { key: "SubjectClass" },
        { key: "Cost" },
        { key: "Action" },
      ],

      fieldsResponsive: [
        { key: "ID" },
        { key: "StudentDetail" },
        { key: "Cost" },
        { key: "Action" },
      ],

      fieldsPackages: [{ key: "Name" }, { key: "Action" }],
      StudentDetailModal: false,
      studentDetails: [],

      DiscountModal: false,
      Discount: "",

      AssignPackageModal: false,
      selectedPackage: "",
      packages: [],

      studentpackages: [],
      FilteredStudentPackages: [],

      StudentModal: false,
      StudentNames: "",
      StudentEmails: "",
      ParentEmails: "",
      ParentPhoneNumbers: "",
      SelectedGradeNames: {},
      gradesName: [],
      SelectedClassNames: {},
      classes: [],

      rates: [],
      selectedRate: [],

      InactiveModal: false,

      ErrorMessage: true,
      user: {},
      small: "",
      fixed: "",
      currentDate: new Date().toISOString().substring(0, 10),

      check: {},

      SelectedStudent: "",
      SelectedStudent2: "",
      SelectedSubject: "",
      SelectedTeacher: "",
      SelectedGrades: "",

      StartTime: "",
      group: "",
      durationID: "",

      languages: [],
      sessions: [],
      times: [],
      subjects: [],
      list: [],
      grades: [],
      dur: [],

      FTModal: false,

      OneToOneForm: true,
      GroupOfTwoForm: false,
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetStudent();
      //this.GetPackage();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    FilteredStudentsList() {
      if (this.SearchQuery === "") return this.FilteredStudents;
      return this.FilteredStudents.filter((item) => {
        //teacher name
        for (const { Name } of item.Packages) {
          if (Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return item;
          }
        }

        if (
          item.Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }

        if (
          item.ParentName.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        if (
          item.ParentEmail.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        const fee = item.Phone?.toString() || "";
        if (fee.indexOf(this.SearchQuery.toString()) > -1) {
          return item;
        }
      });
    },
  },
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    async GetListChild() {
      console.log("masuk");
      this.$API
        .get(this.$AllStudentName, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },

    RefreshData() {
      this.GetStudent();
    },
    ShowAll()
    {
      this.Busy = true;
      const currentDate = new Date(); // Declare currentDate variable here
      this.$API
        .get(this.$ViewStudent + "?status=All", { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
            this.students = this.students.slice(0, this.user.totalStudent);
            this.getPicChild(this.students);
            this.FilteredStudents = this.students;
            this.Busy = false;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "Class"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");

            var statusNames = _.uniq(_.map(response.data, "Status"));
            statusNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.statusOptions = statusNames;
            this.statusOptions.unshift("ALL STATUS");
          }
        });
      

    }, 
    GetStudent() {
      this.Busy = true;
      const currentDate = new Date(); // Declare currentDate variable here
      this.$API
        .get(this.$ViewStudent, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
            this.students = this.students.slice(0, this.user.totalStudent);
            this.getPicChild(this.students);
            this.FilteredStudents = this.students;
            this.Busy = false;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "Class"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");
          }
        });
    },
    getPicChild(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },

    FilteredData() {
      console.log("masuk");
      this.FilteredStudents = this.students;

      if (this.selectedGrade !== "ALL GRADE")
        this.FilteredStudents = _.filter(
          this.FilteredStudents,
          (item) => item.Grade === this.selectedGrade
        );

      if (this.selectedClass !== "ALL CLASS")
        this.FilteredStudents = _.filter(
          this.FilteredStudents,
          (item) => item.Class === this.selectedClass
        );
        if (this.selectedStatus !== "ALL STATUS")
        this.FilteredStudents = _.filter(
          this.FilteredStudents,
          (item) => item.Status === this.selectedStatus
        );
    },
    OpenStudentModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.StudentDetailModal = true;
    },
    OpenDiscountModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.DiscountModal = true;
    },

    UpdateDiscount: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Discount", this.Discount);

      return this.$API
        .post(this.$UpdateDiscount, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.DiscountModal = false;
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update package ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenAssignPackageModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });

      this.$API
        .get(this.$ViewPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.Busy = false;
            this.packages = response.data;
          }
        });

      this.$API
        .get(this.$GetListStudentPackage + "?manualId=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.studentpackages = response.data;
            this.FilteredStudentPackages = this.studentpackages;
          }
        });

      this.AssignPackageModal = true;
    },

    async CreateAssignPackage() {
      const formData = new FormData();

      formData.append("ManualStudentId", this.StudentId);
      formData.append("TuitionPackageId", this.selectedPackage.Id);

      return this.$API
        .post(this.$InsertAssignStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            //this.Busy = false;
            //this.AssignPackageModal = false;
            //this.$dialog.alert("Success Save").then(function () {});
            this.GetPackageManualStudent(this.StudentId);
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenDeletePackages(item, Id) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            //   this.$dialog.alert("Details Deleted!");

            this.GetPackageManualStudent(Id);

            // this.AssignPackageModal = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    GetPackageManualStudent(Id) {
      return this.$API
        .get(this.$GetListStudentPackage + "?manualId=" + Id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            // this.Busy = false;
            this.studentpackages = response.data;
            this.GetStudent();
          }
        });
    },
    OpenStudentDirectFT(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.languages = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.sessions = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.times = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$Durations)
        .then(
          function (response) {
            this.dur = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });

      this.$API
        .get(this.$ViewStudent, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });

      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
          }
        });
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });

      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StudentNames = this.info.Name;

            this.SetupSelectedOption();
          }
        });
      this.FTModal = true;
    },
    OpenUpdateStudent(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$ListGradeTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.gradesName = response.data;
          }
        });

      this.$API
        .get(this.$ListClassTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
          }
        });

      this.$API
        .get(this.$GetRateType, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rates = response.data;
          }
        });

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StudentNames = this.info.Name;
            this.StudentEmails = this.info.StudentEmail;
            this.ParentNames = this.info.ParentName;
            this.ParentEmails = this.info.ParentEmail;
            this.ParentEmailPrevious = this.info.ParentEmail;
            this.ParentPhoneNumbers = this.info.ParentPhoneNumber;
            this.Grades = this.info.Grade;
            this.ClassNames = this.info.Class;
            this.RateTypes = this.info.RateType;

            this.SetupSelectedOption();
          }
        });
      this.StudentModal = true;
    },
    SetupSelectedOption() {
      this.SelectedGradeNames = _.find(this.gradesName, {
        Name: this.Grades,
      });
      this.SelectedClassNames = _.find(this.classes, {
        Name: this.ClassNames,
      });

      this.SelectedStudent = _.find(this.students, {
        Name: this.StudentNames,
      });
    },

    UpdateStudent: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Name", this.StudentNames);
      formData.append("StudentEmail", this.StudentEmails);
      formData.append("ParentEmail", this.ParentEmails);
      formData.append("ParentEmailPrevious", this.ParentEmail);
      formData.append("ParentPhoneNumber", this.ParentPhoneNumbers);
      formData.append("Grade", this.SelectedGradeNames.Name);
      formData.append("ClassName", this.SelectedClassNames.Name);

      return this.$API
        .post(this.$UpdateManualStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.StudentModal = false;
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    DownloadSuccess() {
      console.log("Success");
    },
    DownloadFail(val) {
      console.log("Error generating CSV file.");
      console.log(val);
    },
    ConvertCsvToJson() {
      if (this.check.CurrentCountStudent >= this.check.NumberOfStudent) {
        alert("You have reached limit register student");
      } else {
        this.parsedCsvData = [];
        this.files = this.$refs.myFiles.files;

        if (this.files.length == 0) return;

        var reader = new FileReader();
        reader.onload = () => {
          var csvResult = this.$papa.parse(reader.result);
          csvResult.data.splice(0, 1);

          for (var i = 0; i < csvResult.data.length; i++) {
            var obj = {
              Name: csvResult.data[i][0],
              StudentEmail: csvResult.data[i][1],
              ParentEmail: csvResult.data[i][2],
              ParentPhoneNumber: csvResult.data[i][3],
              Grade: csvResult.data[i][4],
              ClassName: csvResult.data[i][5],
              ParentName: csvResult.data[i][6],
            };
            this.parsedCsvData.push(obj);
          }
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(this.files[0]);
      }
    },
    InsertImportStudent() {
      if (this.check.CurrentCountStudent >= this.check.NumberOfStudent) {
        alert("You have reached limit register student");
      } else {
        const formData = new FormData();

        for (var i = 0; i < this.parsedCsvData.length; i++) {
          formData.append("studentJson", JSON.stringify(this.parsedCsvData));
        }

        return this.$API
          .post(this.$InsertImportStudent, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              alert("Upload complete.");
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },

    OpenInactiveModal(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
      this.InactiveModal = true;
    },
    UpdateStudentStatus: function () {
      const formData = new FormData();
      formData.append("Id", this.StudentId);
      formData.append("Status", "inactive");

      return this.$API
        .post(this.$UpdateStatusStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.InactiveModal = false;
            this.$dialog.alert("Success saved").then(function () {});
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GoToRenew() {
      // window.open(
      //   "https://www.pickiddo.com/RenewPackage?UserGroupId=" +
      //     this.user.usergroupId,
      //   "_blank"
      // );
      this.$router.push("/Billing");
    },
    OpenOneToOne() {
      this.OneToOneForm = true;
      this.GroupOfTwoForm = false;
    },
    OpenGroupOfTwo() {
      this.GroupOfTwoForm = true;
      this.OneToOneForm = false;
    },
    DirectOneToOne() {
      const formData = new FormData();

      formData.append("IsGroup", false);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrades.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorOneToOne, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.$dialog.alert("Success saved find tutor").then(function () {});
            this.FTModal = false;
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    DirectGroupOfTwo() {
      const formData = new FormData();

      formData.append("IsGroup", true);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("studentId2", this.SelectedStudent2.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrades.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorGrouping, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.$dialog.alert("Success saved find tutor").then(function () {});
            this.FTModal = false;
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>
<style>
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
.btn-act {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #7460ee;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.custom-btn-lights {
  background: #7460ee;
  border: 1px solid #7460ee;
  color: #ffffff;
}
.btn-primary {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.btn-primary:hover {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
fieldset {
  border: 1px solid #c9c9c9;
  border-radius: 5px;
}
legend {
  display: block;
  width: auto;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
  margin-left: 10px;
  font-weight: 600;
}
</style>
